var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('b-badge',{staticClass:"p-1 font-weight-normal",attrs:{"variant":_vm.variant}},[_vm._v(" "+_vm._s(_vm.$t("competition.state." + _vm.value.status))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }